import EditPostScreen from "../modules/post/EditPostScreen"

export default function EditPost() {
  return (
    <>
      <EditPostScreen />
    </>
  )
}
